import React from 'react';
import { useParams } from 'react-router-dom';

import {
  MenteeDetails,
  useGetMenteeModulesQuery,
} from 'features/moduleManagement';
import AddMenteeModuleModal from './AddMenteeModuleModal';
import DeleteMenteeModuleModal from './DeleteMenteeModuleModal';
import ErrorLayout from 'components/ErrorLayout';
import GlobalLoader from 'components/GlobalLoader';
import Loader from 'components/Loader';
import MenteeModulesTableRenderer from './MenteeModulesTableRenderer';
import SaveOrderChangesButton from './SaveOrderChangesButton';
import UpdateMenteeModuleStatusModal from './UpdateMenteeModuleStatusModal';
import ViewMiscellaneousButton from './ViewMiscellaneousButton';

function ManageMenteeModulesPage() {
  const { email } = useParams();
  const { isLoading, data, error, refetch, isFetching } =
    useGetMenteeModulesQuery(email);

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load mentee modules"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data) {
    const meta = data.meta;
    const menteeModules = data.data;
    const { user, super_batch: superBatch } = meta;

    return (
      <>
        <GlobalLoader isVisible={isFetching} />
        <DeleteMenteeModuleModal />
        <AddMenteeModuleModal
          user={user}
          superBatch={superBatch}
        />
        <UpdateMenteeModuleStatusModal />
        <div className="row space-between m-t-m">
          <MenteeDetails
            user={user}
            superBatch={superBatch}
          />
          <div className="row align-c">
            <ViewMiscellaneousButton />
          </div>
        </div>
        <MenteeModulesTableRenderer menteeModules={menteeModules} />
        <SaveOrderChangesButton />
      </>
    );
  }
}

export default ManageMenteeModulesPage;
